module.exports = __webpack_public_path__ + "img/img10.c9be703e.jpg";